module.exports = __webpack_public_path__ + "static/media/france.a33a870d.svg";